// sessionStorage key: set when the user skips or finishes the SafetyLoop import
// wizard so it doesn't pop again in this tab. The SSO landing page clears it, so
// every fresh arrival from SafetyLoop offers the import again.
// eslint-disable-next-line import/prefer-default-export
export const IMPORT_DISMISSED_KEY = 'pl-sl-import-dismissed';
